<template>
    <BasicModal v-if="show" title="Cookie settings" @close="onClose">
        <div class="cookie-consent-modal">
            <p class="cookie-consent-info">
                We use essential cookies to keep you logged in. To give you the
                best experience — including high-resolution satellite maps and
                photos of your destinations from Wikipedia and Pexels — we load
                content from trusted external services. You can change this at
                any time in your settings.
            </p>
            <div class="cookie-consent-actions">
                <Bttn
                    id="consent-essential"
                    @click="consentStore.set('essential')"
                    >Essential only</Bttn
                >
                <Bttn
                    id="consent-external"
                    @click="consentStore.set('external')"
                    >Allow all</Bttn
                >
            </div>
            <p class="cookie-consent-link">
                <router-link to="/cookies">Cookies</router-link>
                ·
                <router-link to="/privacy">Privacy policy</router-link>
            </p>
        </div>
    </BasicModal>
</template>

<script>
import BasicModal from "js/components/modals/BasicModal.vue";
import { useConsentStore } from "js/stores/consentStore.js";

export default {
    name: "CookieConsentModal",
    components: {
        BasicModal,
    },
    data() {
        return {
            consentStore: useConsentStore(),
        };
    },
    computed: {
        show() {
            return !this.consentStore.decided || this.consentStore.modalOpen;
        },
    },
    methods: {
        onClose() {
            if (this.consentStore.decided) {
                this.consentStore.close();
            } else {
                this.consentStore.set("essential");
            }
        },
    },
};
</script>
